export default __webpack_public_path__ + "43a26134ccc6c29591f35fea2446f503.png";